import { normalizeAutomationOutputValue } from "./PagesContainerUtils";

const humanizeApiName = (key) =>
  String(key || "")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());

/**
 * Collect inline *_error variables for layout-style Error modal (toast list).
 * Example line: "Account : Account is required."
 */
export const collectPagesFieldErrorsForToast = (outputResponse = {}) => {
  if (!outputResponse || typeof outputResponse !== "object") {
    return [];
  }
  const lines = [];
  Object.entries(outputResponse).forEach(([key, raw]) => {
    if (!key || !/_error$/i.test(String(key))) {
      return;
    }
    const message = normalizeAutomationOutputValue(key, raw);
    if (
      message == null ||
      message === "" ||
      (typeof message === "string" && message.trim() === "") ||
      String(message).toLowerCase() === "null"
    ) {
      return;
    }
    const fieldKey = String(key).replace(/_error$/i, "");
    const label = humanizeApiName(fieldKey);
    lines.push(`${label} : ${message}`);
  });
  return lines;
};

export const hasPagesInlineFieldErrors = (outputResponse = {}) =>
  collectPagesFieldErrorsForToast(outputResponse).length > 0;
